import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { AnnaBoot } from '../components/boot/AnnaBoot';
const KEY = 'anna-booted';
interface BootApi {
  booting: boolean;
  /** Play the boot sequence again over the current screen */
  replay: () => void;
}
const BootContext = createContext<BootApi>({
  booting: false,
  replay: () => undefined
});

/** Plays the boot sequence once per session over whichever screen opens first; replayable from anywhere. */
export function BootProvider({
  enabled,
  children
}: {
  enabled: boolean;
  children: React.ReactNode;
}) {
  const [booting, setBooting] = useState(() => enabled && typeof window !== 'undefined' && !window.sessionStorage.getItem(KEY));
  const [run, setRun] = useState(0);
  const done = useCallback(() => {
    window.sessionStorage.setItem(KEY, '1');
    setBooting(false);
  }, []);
  const replay = useCallback(() => {
    setRun(r => r + 1);
    setBooting(true);
  }, []);
  const value = useMemo(() => ({
    booting,
    replay
  }), [booting, replay]);
  return <BootContext.Provider value={value} data-id="element-1790" data-mp="2yh3hyq76fe7t">
      {children}
      <AnimatePresence data-id="element-1791" data-mp="2yiocwgxekz67">{booting && <AnnaBoot key={`boot-${run}`} onDone={done} data-id="element-1792" data-mp="3c88dbg3ihkcc" />}</AnimatePresence>
    </BootContext.Provider>;
}
export function useBoot(): BootApi {
  return useContext(BootContext);
}